module.exports = __webpack_public_path__ + "static/media/el fath still 02.b2d9afcb.webp";